(function () {

  'use strict';

  angular.module('Home', []);
  angular.module('Sites', []);
  angular.module('PrinterList', ['Shared']);
  angular.module('PrinterProperties', []);
  angular.module('PrinterPropertiesMulti', []);
  angular.module('PrintQueueDriverList', []);
  angular.module('AddPrinter', []);
  angular.module('AddUser', []);
  angular.module('UnknownNetworks', []);
  angular.module('PrinterIssueList', []);
  angular.module('PrinterIssue', []);
  angular.module('WorkstationList', ['Shared']);
  angular.module('UserList', []);
  angular.module('UserProperties', []);
  angular.module('UserPropertiesMulti', []);
  angular.module('AuthenticationSettings', ['PrintixProviderIdp']);
  angular.module('PrinterIdSign', []);
  angular.module('WorkstationProperties', []);
  angular.module('WorkflowProperties', []);
  angular.module('DestinationProfileProperties', []);
  angular.module('SetupAssistant', []);
  angular.module('Setup', []);
  angular.module('DeployAssistant', []);
  angular.module('SoftwareDistribution', []);
  angular.module('SnmpConfigurationProperties', []);
  angular.module('OnDeviceConfigProperties', []);
  angular.module('SignInProfileProperties', []);
  angular.module('History', []);
  angular.module('Support', []);
  angular.module('Subscription', []);
  angular.module('Settings', []);
  angular.module('GroupList', []);
  angular.module('GroupProperties', []);
  angular.module('NetworkList', []);
  angular.module('NetworkProperties', []);
  angular.module('NetworkUnknownProperties', []);
  angular.module('PrintQueueProperties', []);
  angular.module('PrintQueuePropertiesMulti', []);
  angular.module('PrintQueueList', []);
  angular.module('Shared', []);
  angular.module('Applications', []);

  // eslint-disable-next-line angular/module-getter
  angular.module(angular.element('html').attr('ng-app'), [
    'infinite-scroll',
    'angular-uuid',
    'ngAnimate',
    'ui.select',
    'ngCookies',
    'ngRoute',
    'angular.filter',
    'angularMoment',
    'focusOn',
    'ngBootbox',
    'toastr',
    'PrintixUtils',
    'PrintixError',
    'PrintixLanguageMenu',
    'PrintixMainMenu',
    'PrintixNavigationBar',
    'PrintixPageHeader',
    'dndLists',
    'LocalStorageModule',
    'monospaced.qrcode',
    'ng.deviceDetector',
    'daterangepicker',
    'angular-click-outside',
    'pusher-angular',
    'rzSlider',
    'cfp.hotkeys',
    'PrintixAuth',
    'PrintixAPIAdmin',
    'PrintixAPIDownload',
    'PrintixInfoGroup',
    'PrintixInfoPrinter',
    'PrintixInfoPrintQueue',
    'PrintixInfoUser',
    'PrintixInfoWorkstation',
    'PrintixInfoNetwork',
    'PrintixProviderPrinter',
    'PrintixProviderUser',
    'PrintixProviderWorkstation',
    'PrintixProviderTenant',
    'PrintixProviderIdp',
    'RegexProvider',
    'PrintixProviderNetwork',
    'PrintixProviderGroup',
    'OnDeviceConfigProvider',
    'SitesProvider',
    'GoProfileProvider',
    'EnumerationProvider',
    'PrintRulesProvider',
    'PrintQueuePropertiesProvider',
    'CloudStorageProvider',
    'WorkflowProvider',
    'DestinationProfileProvider',
    'MetadataProfileProvider',
    'DataSourceProvider',
    'SnmpConfigurationProvider',
    'PrinterVendorProvider',
    'DataExtractProvider',
    'ApplicationsProvider',
    'WebhookProvider',
    'SoftwareProvider',
    'PrintixProviderMetric',
    'PrintixEventService',
    'Home',
    'Sites',
    'OnDeviceConfigProperties',
    'SignInProfileProperties',
    'PrinterProperties',
    'NetworkProperties',
    'UserProperties',
    'GroupProperties',
    'WorkstationProperties',
    'WorkflowProperties',
    'DestinationProfileProperties',
    'NetworkUnknownProperties',
    'PrintQueueProperties',
    'PrinterPropertiesMulti',
    'UserPropertiesMulti',
    'PrintQueuePropertiesMulti',
    'PrinterList',
    'PrintQueueDriverList',
    'AddPrinter',
    'AddUser',
    'UnknownNetworks',
    'PrinterIssueList',
    'PrinterIssue',
    'WorkstationList',
    'PrintQueueList',
    'UserList',
    'AuthenticationSettings',
    'PrinterIdSign',
    'SetupAssistant',
    'Setup',
    'DeployAssistant',
    'SoftwareDistribution',
    'SnmpConfigurationProperties',
    'Support',
    'History',
    'Subscription',
    'Settings',
    'GroupList',
    'NetworkList',
    'WorkerModule',
    'angular-jsvat',
    'angularFileUpload',
    'digestOverride',
    'CopilotProvider',
    'Applications',
    'ngSanitize'
  ])

    .constant('USER_RIGHTS', {
      ACCESS_GRANT: 'ACCESS_GRANT',
      CHANGE_PRINTER_ACTIVE_STATE: 'RESOURCE_PRINTER_ACTIVE',
      OPEN_ADMINISTRATOR_WEB_APP: 'ADMIN_LOGIN',
      PRINT_ID_SIGN: 'PRINT_ID_SIGN',
      RESOURCE_PRINTJOB_CREATE: 'RESOURCE_PRINTJOB_CREATE',
      ADMIN_LOGIN: 'ADMIN_LOGIN'
    })

    .constant('USER_ROLES', {
      USER: 'USER',
      SYSTEM_MANAGER: 'SYSTEM_MANAGER',
      SYSTEM_OBSERVER: 'SYSTEM_OBSERVER',
      TECHNICIAN: 'TECHNICIAN',
      GUEST_USER: 'GUEST_USER',
      KIOSK_USER: 'KIOSK_USER'
    })

    .constant('SETUP_ASSISTANT', {
      SHOW_INTRODUCTION: 'SHOW_INTRODUCTION',
      DOWNLOAD_CLIENT: 'DOWNLOAD_CLIENT',
      AWAIT_WORKSTATION: 'AWAIT_WORKSTATION',
      AWAIT_INITIAL_DISCOVERY: 'AWAIT_INITIAL_DISCOVERY',
      OPEN_DASHBOARD: 'OPEN_DASHBOARD',
      SETUP_AUTH: 'SETUP_AUTH',
      ADD_USER: 'ADD_USER'
    })

    .constant('URL_PARAMS', {
      PRINTER_URL: {
        ROUTE: 'printerURL',
        LOCATION: ':printerURL'
      },
      GO_PROFILE_ID: {
        ROUTE: 'goProfileId',
        LOCATION: ':goProfileId'
      },
      SIGN_IN_PROFILE_ID: {
        ROUTE: 'signInProfileId',
        LOCATION: ':signInProfileId'
      },
      SITES_IDS: {
        ROUTE: 'siteIds',
        LOCATION: ':siteIds'
      },
      PRINT_QUEUE_URL: {
        ROUTE: 'printQueueURL',
        LOCATION: ':printQueueURL'
      },
      USER_ID: {
        ROUTE: 'userId',
        LOCATION: ':userId'
      },
      WORKSTATION_ID: {
        ROUTE: 'workstationId',
        LOCATION: ':workstationId'
      },
      WORKFLOW_ID: {
        ROUTE: 'workflowId',
        LOCATION: ':workflowId'
      },
      DESTINATION_PROFILE_ID: {
        ROUTE: 'destinationProfileId',
        LOCATION: ':destinationProfileId'
      },
      GROUP_ID: {
        ROUTE: 'groupId',
        LOCATION: ':groupId'
      },
      NETWORK_ID: {
        ROUTE: 'networkId',
        LOCATION: ':networkId'
      },
      NETWORK_UNKNOWN_ID: {
        ROUTE: 'networkUnknownId',
        LOCATION: ':networkUnknownId'
      },
      SNMP_CONFIG_URL: {
        ROUTE: 'snmpConfigUrl',
        LOCATION: ':snmpConfigUrl'
      },
      OS: {
        ROUTE: 'os',
        LOCATION: ':os'
      },
      SHOW_SECTION: {
        ROUTE: 'showSection'
      },
      SHOW_QUEUE_SECTION: {
        ROUTE: 'queueSection'
      },
      SHOW_SETTINGS_SECTION: {
        ROUTE: 'settingsSection'
      },
      SHOW_PRINTER_SECTION: {
        ROUTE: 'printerSection'
      },
      SHOW_WORKSTATION_SECTION: {
        ROUTE: 'workstationSection'
      },
      SHOW_USER_SECTION: {
        ROUTE: 'userSection'
      },
      SHOW_SUBSCRIPTION_SECTION: {
        ROUTE: 'subscriptionSection'
      },
      SHOW_NETWORK_SECTION: {
        ROUTE: 'networkSection'
      },
      SHOW_NETWORK_UNKNOWN_SECTION: {
        ROUTE: 'networkUnknownSection'
      },
      SHOW_AUTH_SECTION: {
        ROUTE: 'authSection'
      },
      SHOW_GROUP_SECTION: {
        ROUTE: 'groupSection'
      },
      SHOW_APPLICATIONS_SECTION: {
        ROUTE: 'applicationsSection'
      }
    })

    .constant('URLS', {
      TEST_IDENTITY_PROVIDERS: '/admin/app/components/authenticationSettings/testIdentityProviders/',
      GROUPS_TEST_PAGE: '/admin/groupsTestPage.html',
      HOME: '/dashboard',
      SITES: '/sites/:siteIds?',
      PRINTER_LIST: '/printers',
      PRINTER_PROPERTIES: '/printerProperties/:printerURL',
      PRINTER_PROPERTIES_MULTI: '/printerPropertiesMulti/:printerURL',
      ADD_PRINTER: '/addPrinter',
      ADD_USER: '/addUser',
      PRINTER_ISSUE_LIST: '/printerIssueList',
      PRINTER_ISSUE: '/printerIssue/:printerURL',
      WORKSTATION_LIST: '/computers',
      USER_LIST: '/users',
      USER_PROPERTIES: '/userProperties/:userId',
      USER_PROPERTIES_MULTI: '/userPropertiesMulti/:userId',
      AUTHENTICATION_SETTINGS: '/authentication',
      PRINTER_ID_SIGN: '/sign/:printerURL',
      WORKSTATION_PROPERTIES: '/computerProperties/:workstationId',
      WORKSTATION_PROPERTIES_MULTI: '/computerPropertiesMulti/:workstationId',
      WORKFLOW_PROPERTIES: '/workflowProperties/:workflowId',
      DESTINATION_PROFILE_PROPERTIES: '/destinationProfileProperties/:destinationProfileId',
      HISTORY: '/history',
      SETUP_ASSISTANT: '/setupAssistant',
      SETUP: '/setup',
      DEPLOY_ASSISTANT: '/implementationAssistant',
      SUPPORT: '/support',
      PRINT_LATER: '/freedom',
      SUBSCRIPTION: '/subscription',
      SETTINGS: '/settings',
      GROUP_LIST: '/groups',
      GROUP_PROPERTIES: '/groupProperties/:groupId',
      NETWORK_LIST: '/networks',
      NETWORK_PROPERTIES: '/networkProperties/:networkId',
      NETWORK_UNKNOWN_PROPERTIES: '/networkUnknownProperties/:networkUnknownId',
      PRINT_QUEUE_DRIVER_LIST: '/printQueueProperties/:printerURL/:printQueueURL/printQueueDrivers/:os',
      PRINT_QUEUE_PROPERTIES: '/printQueueProperties/:printerURL/:printQueueURL',
      PRINT_QUEUE_PROPERTIES_MULTI: '/printQueuePropertiesMulti/:printQueueURL',
      PRINT_QUEUE_LIST: '/printQueues',
      SOFTWARE_DISTRIBUTION_PAGE: '/software',
      SNMP_CONFIGURATION_PROPERTIES: '/snmpConfiguration/:snmpConfigUrl',
      GO_PROFILE_PROPERTIES: '/goConfiguration/:goProfileId',
      SIGN_IN_PROFILE_PROPERTIES: '/signInProfile/:signInProfileId',
      UNNOWN_NETWORKS: '/unknownNetworks',
      APPLICATIONS: '/applications'
    })

    .constant('TEMPLATE_PATHS', {
      HOME_VIEW_PATH: 'app/components/home/homeView.html',
      SITES_VIEW_PATH: 'app/components/sites/sitesView.html',
      PRINTER_LIST_VIEW_PATH: 'app/components/printerList/printerListView.html',
      PRINTER_PROPERTIES_VIEW_PATH: 'app/components/printerProperties/printerPropertiesView.html',
      PRINTER_PROPERTIES_MULTI_VIEW_PATH: 'app/components/printerPropertiesMulti/printerPropertiesMultiView.html',
      PRINT_QUEUE_DRIVER_LIST_VIEW_PATH: 'app/components/printQueueDriverList/printQueueDriverListView.html',
      PRINTER_ISSUE_LIST_VIEW_PATH: 'app/components/printerIssueList/printerIssueListView.html',
      PRINTER_ISSUE_VIEW_PATH: 'app/components/printerIssue/printerIssueView.html',
      ADD_PRINTER_VIEW_PATH: 'app/components/addPrinter/addPrinterView.html',
      ADD_USER_VIEW_PATH: 'app/components/addUser/addUserView.html',
      WORKSTATION_LIST_VIEW_PATH: 'app/components/workstationList/workstationListView.html',
      USER_LIST_VIEW_PATH: 'app/components/userList/userListView.html',
      USER_PROPERTIES_VIEW_PATH: 'app/components/userProperties/userPropertiesView.html',
      USER_PROPERTIES_MULTI_VIEW_PATH: 'app/components/userPropertiesMulti/userPropertiesMultiView.html',
      AUTHENTICATION_SETTINGS_VIEW_PATH: 'app/components/authenticationSettings/authenticationSettingsView.html',
      PRINTER_ID_SIGN_VIEW_PATH: 'app/components/printerIdSign/printerIdSignView.html',
      WORKSTATION_PROPERTIES_VIEW_PATH: 'app/components/workstationProperties/workstationPropertiesView.html',
      WORKFLOW_PROPERTIES_VIEW_PATH: 'app/components/workflowProperties/workflow.template.html',
      DESTINATION_PROFILE_PROPERTIES_VIEW_PATH: 'app/components/destinationProfileProperties/destinationProfile.template.html',
      HISTORY_VIEW_PATH: 'app/components/history/historyView.html',
      SETUP_ASSISTANT_VIEW_PATH: 'app/components/setupAssistant/setupAssistantView.html',
      SETUP_VIEW_PATH: 'app/components/setup/setup.template.html',
      DEPLOY_ASSISTANT_VIEW_PATH: 'app/components/deployAssistant/deployAssistant.template.html',
      SUPPORT_VIEW_PATH: 'app/components/support/supportView.html',
      SUBSCRIPTION_VIEW_PATH: 'app/components/subscription/subscriptionView.html',
      SETTINGS_VIEW_PATH: 'app/components/settings/settingsView.html',
      DELETE_NETWORK_TEMPLATE_PATH: 'app/components/networkList/deleteNetworkDialog.html',
      GROUP_LIST_TEMPLATE_PATH: 'app/components/groupList/groupListView.html',
      GROUP_PROPERTIES_VIEW_PATH: 'app/components/groupProperties/groupPropertiesView.html',
      DRIVER_CONFIG_CREATE_DIALOG: 'app/components/printQueueDriverList/driverConfigCreateDialog.html',
      DRIVER_EDIT_DIALOG: 'app/components/printQueueDriverList/driverEditDialog.html',
      NETWORK_LIST_TEMPLATE_PATH: 'app/components/networkList/networkListView.html',
      NETWORK_PROPERTIES_TEMPLATE_PATH: 'app/components/networkProperties/networkPropertiesView.html',
      NETWORK_UNKNOWN_PROPERTIES_TEMPLATE_PATH: 'app/components/networkUnknownProperties/networkUnknownPropertiesView.html',
      UNKNOWN_NETWORK_INFO_TEMPLATE_PATH: 'app/components/networkList/unknownNetworkInfo.html',
      PRINT_QUEUE_PROPERTIES_VIEW_PATH: 'app/components/printQueueProperties/printQueuePropertiesView.html',
      PRINT_QUEUE_PROPERTIES_MULTI_VIEW_PATH: 'app/components/printQueuePropertiesMulti/printQueuePropertiesMultiView.html',
      PRINT_QUEUE_LIST_VIEW_PATH: 'app/components/printQueueList/printQueueListView.html',
      SOFTWARE_DISTRIBUTION_VIEW_PATH: 'app/components/softwareDistribution/softwareDistributionView.template.html',
      SNMP_CONFIGURATION_PROPERTIES_VIEW_PATH: 'app/components/snmpConfigurationProperties/snmpConfigurationProperties.template.html',
      GO_PROFILE_PROPERTIES_VIEW_PATH: 'app/components/onDeviceConfigProperties/onDeviceConfigProperties.template.html',
      SIGN_IN_PROFILE_PROPERTIES_VIEW_PATH: 'app/components/signInProfileProperties/signInProfileProperties.template.html',
      UNKNOWN_NETWORKS_VIEW_PATH: 'app/components/networkList_unknown/networkList_unknown.view.html',
      ENTER_INVOICE_NUMBER_TEMPLATE_PATH: 'app/components/subscription/enterInvoiceNumber.template.html',
      APPLICATIONS_VIEW_PATH: 'app/components/applications/applicationsView.template.html'
    })

    .constant('API_VALUES', {
      APP_NAMES_URL: 'assets/jsonFiles/appName/appNameItems.json'
    })

    .constant('COUNTRIES_RESOURCES', {
      COUNTRIES: 'assets/jsonFiles/countries/countries.json'
    })

    .constant('STRIPE_PUBLISHABLE_KEY', '__STRIPE_PUBLISHABLE_KEY__')

    .constant('CURRENT_APP_PERMISSION', 'ADMIN_LOGIN')

    .constant('DEFAULT_ITEMS_PER_PAGE', 20)

    .config(function ($routeProvider, $httpProvider, URLS, TEMPLATE_PATHS, $translateProvider, toastrConfig, $locationProvider, $provide) {

      $locationProvider.hashPrefix('');
      $translateProvider.useSanitizeValueStrategy('escaped');

      // SECURITY: Prevent Client-Side Template Injection (CSTI) via angular-translate.
      // The default interpolation calls $interpolate(value) on translation strings,
      // which evaluates {{ }} expressions. If an unrecognised key (e.g. a user-editable
      // entity name) reaches $translate, the name is passed to $interpolate as a
      // template, enabling arbitrary JS execution via constructor.constructor(code)().
      // This codebase uses {0}/{1} placeholders with the stringular filter — not
      // angular-translate's {{ }} parameter interpolation — so skipping $interpolate
      // is safe and closes all CSTI vectors through $translate at once.
      $provide.decorator('$translateDefaultInterpolation', ['$delegate', '$translateSanitization', function ($delegate, $translateSanitization) {
        $delegate.interpolate = function (value, interpolationParams, context, sanitizeStrategy, translationId) {
          let interpolatedText;
          if (angular.isNumber(value)) {
            interpolatedText = '' + value;
          } else if (angular.isString(value)) {
            interpolatedText = $translateSanitization.sanitize(value, 'text', sanitizeStrategy, context);
          } else {
            interpolatedText = '';
          }
          return interpolatedText;
        };
        return $delegate;
      }]);

      $httpProvider.defaults.headers.common = { Accept: 'application/hal+json, application/json' };
      $httpProvider.defaults.headers.post = {};
      $httpProvider.defaults.headers.put = {};
      $httpProvider.defaults.headers.patch = {};

      angular.extend(toastrConfig, {
        iconClasses: {
          error: 'toast--error',
          info: 'toast--info',
          success: 'toast--success',
          warning: 'toast--warning'
        },
        messageClass: 'toast__message',
        titleClass: 'toast__title',
        toastClass: 'toast'
      });

      const currentTenant = function (TenantListService) {
        return TenantListService.resolveCurrentTenant();
      };

      const enums = function (EnumerationService) {
        return EnumerationService.enums || EnumerationService.resolveEnumerations();
      };

      function restrictNavigation(condition) {
        return ['$q', 'TenantListService', 'UserListService', function ($q, TenantListService, UserListService) {
          const deferred = $q.defer();
          TenantListService.resolveCurrentTenant()
            .then(function () {
              UserListService.resolveCurrentUser()
                .then(function (currentUser) {
                  if (condition(currentUser)) {
                    deferred.resolve(undefined); // Proceed to page.
                  } else {
                    deferred.resolve(URLS.HOME); // Navigate to Dashboard.
                  }
                })
                .catch(function () {
                  deferred.resolve(URLS.HOME); // Navigate to Dashboard.
                });
            })
            .catch(function () {
              deferred.resolve(URLS.HOME); // Navigate to Dashboard.
            });
          return deferred.promise;
        }];
      }

      function requirePermission(permission) {
        return restrictNavigation(function (currentUser) {
          return currentUser.hasPermission(permission) || currentUser.hasSitePermission(permission);
        });
      }

      function requireRole(role) {
        return restrictNavigation(function (currentUser) {
          return currentUser.hasPrimaryRole(role) || currentUser.hasSecondaryRole(role);
        });
      }

      function denyAccessToSystemObserver() {
        return restrictNavigation(function (currentUser) {
          return !currentUser.isSystemObserver();
        });
      }

      function denyAccessToSystemObserverNotSiteManager() {
        return restrictNavigation(function (currentUser) {
          return !currentUser.isSystemObserver() || currentUser.isSiteManager();
        });
      }

      $routeProvider
        .when(URLS.HOME, {
          templateUrl: TEMPLATE_PATHS.HOME_VIEW_PATH,
          controller: 'HomeController',
          resolve: {
            currentTenant,
            enums
          }
        })
        .when(URLS.SITES, {
          templateUrl: TEMPLATE_PATHS.SITES_VIEW_PATH,
          controller: 'SitesController',
          reloadOnSearch: false,
          resolve: {
            currentTenant,
            enums
          }
        })
        .when(URLS.PRINTER_LIST, {
          templateUrl: TEMPLATE_PATHS.PRINTER_LIST_VIEW_PATH,
          controller: 'PrinterListController',
          resolve: {
            currentTenant,
            enums
          }
        })
        .when(URLS.PRINTER_PROPERTIES, {
          templateUrl: TEMPLATE_PATHS.PRINTER_PROPERTIES_VIEW_PATH,
          controller: 'PrinterPropertiesController',
          resolve: {
            currentTenant,
            enums
          }
        })
        .when(URLS.PRINTER_PROPERTIES_MULTI, {
          templateUrl: TEMPLATE_PATHS.PRINTER_PROPERTIES_MULTI_VIEW_PATH,
          controller: 'PrinterPropertiesMultiController',
          resolve: {
            currentTenant,
            enums
          }
        })
        .when(URLS.PRINT_QUEUE_DRIVER_LIST, {
          templateUrl: TEMPLATE_PATHS.PRINT_QUEUE_DRIVER_LIST_VIEW_PATH,
          controller: 'PrintQueueDriverListController',
          resolve: {
            currentTenant,
            enums
          }
        })
        .when(URLS.PRINTER_ISSUE_LIST, {
          templateUrl: TEMPLATE_PATHS.PRINTER_ISSUE_LIST_VIEW_PATH,
          controller: 'PrinterIssueListController',
          resolve: {
            currentTenant,
            enums
          }
        })
        .when(URLS.PRINTER_ISSUE, {
          templateUrl: TEMPLATE_PATHS.PRINTER_ISSUE_VIEW_PATH,
          controller: 'PrinterIssueController',
          resolve: {
            currentTenant,
            enums
          }
        })
        .when(URLS.ADD_PRINTER, {
          templateUrl: TEMPLATE_PATHS.ADD_PRINTER_VIEW_PATH,
          controller: 'AddPrinterController',
          resolve: {
            currentTenant,
            enums
          },
          resolveRedirectTo: requirePermission('RESOURCE_NETWORK_ADD_SUB_RESOURCE')
        })
        .when(URLS.ADD_USER, {
          templateUrl: TEMPLATE_PATHS.ADD_USER_VIEW_PATH,
          controller: 'AddUserController',
          resolve: {
            currentTenant,
            enums
          },
          resolveRedirectTo: requirePermission('ACCESS_GRANT')
        })
        .when(URLS.WORKSTATION_LIST, {
          templateUrl: TEMPLATE_PATHS.WORKSTATION_LIST_VIEW_PATH,
          controller: 'WorkstationListController',
          resolve: {
            currentTenant,
            enums
          }
        })
        .when(URLS.USER_LIST, {
          templateUrl: TEMPLATE_PATHS.USER_LIST_VIEW_PATH,
          controller: 'UserListController',
          resolve: {
            currentTenant,
            enums
          }
        })
        .when(URLS.USER_PROPERTIES, {
          templateUrl: TEMPLATE_PATHS.USER_PROPERTIES_VIEW_PATH,
          controller: 'UserPropertiesController',
          resolve: {
            currentTenant,
            enums
          }
        })
        .when(URLS.USER_PROPERTIES_MULTI, {
          templateUrl: TEMPLATE_PATHS.USER_PROPERTIES_MULTI_VIEW_PATH,
          controller: 'UserPropertiesMultiController',
          resolve: {
            currentTenant,
            enums
          }
        })
        .when(URLS.AUTHENTICATION_SETTINGS, {
          templateUrl: TEMPLATE_PATHS.AUTHENTICATION_SETTINGS_VIEW_PATH,
          controller: 'AuthenticationSettingsController',
          resolve: {
            currentTenant,
            enums
          }
        })
        .when(URLS.PRINTER_ID_SIGN, {
          templateUrl: TEMPLATE_PATHS.PRINTER_ID_SIGN_VIEW_PATH,
          controller: 'PrinterIdSignController',
          resolve: {
            currentTenant,
            enums
          }
        })
        .when(URLS.WORKSTATION_PROPERTIES, {
          templateUrl: TEMPLATE_PATHS.WORKSTATION_PROPERTIES_VIEW_PATH,
          controller: 'WorkstationPropertiesController',
          resolve: {
            currentTenant,
            enums
          }
        })
        .when(URLS.WORKFLOW_PROPERTIES, {
          templateUrl: TEMPLATE_PATHS.WORKFLOW_PROPERTIES_VIEW_PATH,
          controller: 'WorkflowPropertiesController',
          resolve: {
            currentTenant,
            enums
          }
        })
        .when(URLS.DESTINATION_PROFILE_PROPERTIES, {
          templateUrl: TEMPLATE_PATHS.DESTINATION_PROFILE_PROPERTIES_VIEW_PATH,
          controller: 'DestinationProfilePropertiesController',
          resolve: {
            currentTenant,
            enums
          }
        })
        .when(URLS.HISTORY, {
          templateUrl: TEMPLATE_PATHS.HISTORY_VIEW_PATH,
          controller: 'HistoryController',
          resolve: {
            currentTenant,
            enums
          }
        })
        .when(URLS.SETUP_ASSISTANT, {
          templateUrl: TEMPLATE_PATHS.SETUP_ASSISTANT_VIEW_PATH,
          controller: 'SetupAssistantController',
          resolve: {
            currentTenant,
            enums
          }
        })
        .when(URLS.SETUP, {
          templateUrl: TEMPLATE_PATHS.SETUP_VIEW_PATH,
          controller: 'SetupController',
          resolve: {
            currentTenant,
            enums
          },
          resolveRedirectTo: requirePermission('RESOURCE_NETWORK_ADD_SUB_RESOURCE')
        })
        .when(URLS.DEPLOY_ASSISTANT, {
          templateUrl: TEMPLATE_PATHS.DEPLOY_ASSISTANT_VIEW_PATH,
          controller: 'DeployAssistantController',
          resolve: {
            currentTenant,
            enums
          }
        })
        .when(URLS.SUPPORT, {
          templateUrl: TEMPLATE_PATHS.SUPPORT_VIEW_PATH,
          controller: 'SupportController',
          resolve: {
            currentTenant,
            enums
          },
          resolveRedirectTo: denyAccessToSystemObserverNotSiteManager()
        })
        .when(URLS.SUBSCRIPTION, {
          templateUrl: TEMPLATE_PATHS.SUBSCRIPTION_VIEW_PATH,
          controller: 'SubscriptionController',
          resolve: {
            currentTenant,
            enums
          }
        })
        .when(URLS.SETTINGS, {
          templateUrl: TEMPLATE_PATHS.SETTINGS_VIEW_PATH,
          controller: 'SettingsController',
          resolve: {
            currentTenant,
            enums
          }
        })
        .when(URLS.GROUP_LIST, {
          templateUrl: TEMPLATE_PATHS.GROUP_LIST_TEMPLATE_PATH,
          controller: 'GroupListController',
          resolve: {
            currentTenant,
            enums
          }
        })
        .when(URLS.GROUP_PROPERTIES, {
          templateUrl: TEMPLATE_PATHS.GROUP_PROPERTIES_VIEW_PATH,
          controller: 'GroupPropertiesController',
          resolve: {
            currentTenant,
            enums
          }
        })
        .when(URLS.NETWORK_LIST, {
          templateUrl: TEMPLATE_PATHS.NETWORK_LIST_TEMPLATE_PATH,
          controller: 'NetworkListController',
          resolve: {
            currentTenant,
            enums
          }
        })
        .when(URLS.NETWORK_PROPERTIES, {
          templateUrl: TEMPLATE_PATHS.NETWORK_PROPERTIES_TEMPLATE_PATH,
          controller: 'NetworkPropertiesController',
          resolve: {
            currentTenant,
            enums
          }
        })
        .when(URLS.NETWORK_UNKNOWN_PROPERTIES, {
          templateUrl: TEMPLATE_PATHS.NETWORK_UNKNOWN_PROPERTIES_TEMPLATE_PATH,
          controller: 'NetworkUnknownPropertiesController',
          resolve: {
            currentTenant,
            enums
          }
        })
        .when(URLS.PRINT_QUEUE_PROPERTIES, {
          templateUrl: TEMPLATE_PATHS.PRINT_QUEUE_PROPERTIES_VIEW_PATH,
          controller: 'PrintQueuePropertiesController',
          resolve: {
            currentTenant,
            enums
          }
        })
        .when(URLS.PRINT_QUEUE_PROPERTIES_MULTI, {
          templateUrl: TEMPLATE_PATHS.PRINT_QUEUE_PROPERTIES_MULTI_VIEW_PATH,
          controller: 'PrintQueuePropertiesMultiController',
          resolve: {
            currentTenant,
            enums
          }
        })
        .when(URLS.PRINT_QUEUE_LIST, {
          templateUrl: TEMPLATE_PATHS.PRINT_QUEUE_LIST_VIEW_PATH,
          controller: 'PrintQueueListController',
          resolve: {
            currentTenant,
            enums
          }
        })
        .when(URLS.SOFTWARE_DISTRIBUTION_PAGE, {
          templateUrl: TEMPLATE_PATHS.SOFTWARE_DISTRIBUTION_VIEW_PATH,
          controller: 'SoftwareDistributionController',
          resolve: {
            currentTenant,
            enums
          }
        })
        .when(URLS.SNMP_CONFIGURATION_PROPERTIES, {
          templateUrl: TEMPLATE_PATHS.SNMP_CONFIGURATION_PROPERTIES_VIEW_PATH,
          controller: 'SnmpConfigurationPropertiesController',
          resolve: {
            currentTenant,
            enums
          }
        })
        .when(URLS.GO_PROFILE_PROPERTIES, {
          templateUrl: TEMPLATE_PATHS.GO_PROFILE_PROPERTIES_VIEW_PATH,
          controller: 'OnDeviceConfigPropertiesController',
          resolve: {
            currentTenant,
            enums
          }
        })
        .when(URLS.SIGN_IN_PROFILE_PROPERTIES, {
          templateUrl: TEMPLATE_PATHS.SIGN_IN_PROFILE_PROPERTIES_VIEW_PATH,
          controller: 'SignInProfilePropertiesController',
          resolve: {
            currentTenant,
            enums
          }
        })
        .when(URLS.UNNOWN_NETWORKS, {
          templateUrl: TEMPLATE_PATHS.UNKNOWN_NETWORKS_VIEW_PATH,
          controller: 'UnknownNetworksController',
          resolve: {
            currentTenant,
            enums
          }
        })
        .when(URLS.APPLICATIONS, {
          templateUrl: TEMPLATE_PATHS.APPLICATIONS_VIEW_PATH,
          controller: 'ApplicationsController',
          resolve: {
            currentTenant,
            enums
          }
        })
        .otherwise({
          redirectTo: URLS.HOME
        });

      $httpProvider.interceptors.push(
        'PrintixRequestHeaderManager',
        'templateCacheBusterInterceptor'
      );

    })

    .service('EnvironmentService', function ($location, $log) {
      const host = $location.host();
      const environment = environments.find(env => host.endsWith(env.match));
      if (environment) {
        this.authBaseUrl = environment.authBaseUrl;
        this.apiBaseUrl = environment.apiBaseUrl;
        this.partnerPortal = environment.partnerPortal;
      } else {
        // Determine if this is a printix.dev environment host.
        // Don't use regex in order to include broadest platform support.
        const index = host.indexOf('.printix.dev');
        const subdomain = index >= 5 ? host.substring(index - 5) : '';
        if (subdomain.indexOf('dev') === 0 && subdomain.length === 17) {
          this.authBaseUrl = 'https://auth.' + subdomain;
          this.apiBaseUrl = 'https://api.' + subdomain;
          this.partnerPortal = 'https://partners.' + subdomain;
        } else {
          $log.error('Failed to detect current environment!');
        }
      }
    })

    .run(function ($rootScope, $location, $filter, EnvironmentService, APIAdmin, USER_RIGHTS, URLS, APIDownload, $window, EventService,
      TenantListService, PrinterListService, UserListService, WorkstationListService, API_VALUES,
      ArrayPrototypes, PrintixErrorService, $http, Auth, PageTitleManager, AutoCloseModelOnNavChange,
      NetworkListService, GroupListService, MetricListService, $route,
      COUNTRIES_RESOURCES, $timeout, EnumerationService, CopilotService) {

      const originalLocationPathFunction = $location.path;
      $location.path = function (path, reload) {
        if (reload === false) {
          const lastRoute = $route.current;
          const deregister = $rootScope.$on('$locationChangeSuccess', function () {
            $route.current = lastRoute;
            deregister();
          });
          $timeout(deregister, 200);
        }
        return originalLocationPathFunction.apply($location, [path]);
      };

      $rootScope.appNameItems = [];
      $rootScope.currentAppName = '';
      $rootScope.clientNameValue = '';
      $rootScope.captionList = [];
      $rootScope.urls = URLS;
      $rootScope.partnerPortal = EnvironmentService.partnerPortal;
      $rootScope.copilotChatOpen = false;
      $rootScope.showCopilot = false;

      // eslint-disable-next-line angular/on-watch
      $rootScope.$watch(function () {
        return TenantListService;
      }, function () {
        if (TenantListService.currentTenant?.info._embedded.productsAndFeatures.products?.FREEDOM?.enabled) {
          $rootScope.showCopilot = true;
        }
      }, true);

      // eslint-disable-next-line angular/on-watch
      $rootScope.$watch(function () {
        return CopilotService.state.chatOpen;
      }, function (newValue, oldValue) {
        $rootScope.copilotChatOpen = newValue;
      });

      $rootScope.readAppNameItems = function () {
        $http.get(API_VALUES.APP_NAMES_URL, { cache: true })
          .then(function (response) {
            $rootScope.appNameItems = [];
            angular.forEach(response.data, function (appNameItem) {
              $rootScope.appNameItems.push(appNameItem);
            });
            if ($rootScope.appNameItems && $rootScope.appNameItems.length > 0) {
              $rootScope.clientNameValue = $rootScope.appNameItems.findElement({
                key: 'Client'
              }).value;
              $rootScope.redirectorNameValue = $rootScope.appNameItems.findElement({
                key: 'Redirector'
              }).value;
              $rootScope.currentAppName = $rootScope.appNameItems.findElement({
                key: 'Admin'
              }).value;
              $rootScope.currentOEM = $rootScope.appNameItems.findElement({
                key: 'Printix'
              }).value;
              $rootScope.configuratorNameValue = $rootScope.appNameItems.findElement({
                key: 'Configurator'
              }).value;
              $rootScope.powerPdfNameValue = $rootScope.appNameItems.findElement({
                key: 'PowerPDF'
              }).value;
            } else {
              throw new Error('$rootScope.readAppNameItems: $rootScope.appNameItems is missing or it is empty');
            }
          })
          .catch(function () {
          });
      };

      $rootScope.readAppNameItems();

    });

})();
